import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  menuItem: {
    fontSize: 14,
    color: theme.colorPalette.green_80
  }
});

export default makeStyles(styles);
